class Env {
  constructor() {
    //Local
    //this.apiUrl = "http://192.168.86.105:8000/api/V0.1";
    //Adresse prod
    this.apiUrl = "https://eguichet.sonabel.bf/gateway/api/V0.1/";
    //Server Test
    // this.apiUrl = "http://10.210.210.14:8080/api/V0.1";
    this.apiStorage = "https://eguichet.sonabel.bf/gateway/storage/api/v1/pdf/upload/";
;
  }
}
export default Env;
